module.exports = __webpack_public_path__ + "static/img/no-image.b4ea200.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-image.jpg
// module id = N7sa
// module chunks = 0